let isVisible   = false
let wrapEl      = null
let openBtn     = null
let closeBtn    = null


export function initialize() {
  if (window.innerWidth >= 1024) return

  openBtn  = document.querySelector('.header__nav-open')
  closeBtn = document.querySelector('.header__nav-close')
  wrapEl   = document.querySelector('.header__primary-nav')

  // Stop everything if any of the above elements do not exist.
  if (!openBtn || !closeBtn || !wrapEl) {
    return
  }

  addListeners()
}


export function addListeners() {
  openBtn.addEventListener('click', toggleNav, false)
  closeBtn.addEventListener('click', toggleNav, false)
  document.addEventListener('keyup', handleKeyPresses, false)
}


export function handleKeyPresses(event) {
  if (isVisible && (event.keyCode === 27)) {
    toggleNav(event)
  }
}


export function toggleNav(event) {
  openBtn.classList.toggle('visuallyhidden')
  closeBtn.classList.toggle('visuallyhidden')
  wrapEl.classList.toggle('is-visible')
  isVisible = !isVisible
  event.stopPropagation()
}
